export const desktopWidth = 1024
export const recaptchaKey = '6Lce4KcUAAAAABGKupP_l1JmBkkDNj39TOOU3ulX'
